module.exports = __webpack_public_path__ + "img/logo_TECT.83dc7eea.png";